import React, { useState, CSSProperties, memo, useEffect } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";

import { FaEdit, FaPlus } from "react-icons/fa";
import { Btn } from "../../../AbstractElements";
import {
  useGETCities,
  UpdateCities,
  useAllCityAndCategory,
  useAddCityCategory,
  useDeleteCity,
} from "./hooks/useCity";
import { useGradeMastersData } from "../Grade Master/hooks/useGradeMaster";
import { showToast } from "../../../utils/toastUtils";

type props = {};
interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

type cityResponse = {
  Cityname: string;
  Category: string;
  Citycategoryid: number;
  GradeId: number;
  Itownid: number;
  GradeMaster?: {
    GradeName?: string;
    Gradeid?: number;
  };
};

type ApiresponseDropDownData = {
  id: number;
  label: string;

  // extravalue
  value?: { Itownid: string };
  Citycategoryid: number;
  Cityname: string;
  Itownid: string;
};

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /><span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);

const CityCategory = (props: props) => {
  const [isModal, setIsModal] = useState(false);
  const [editCity, setEditCity] = useState<any>(null);

  const [selectCityOptions, setSelectCityOptions] = useState<{
    id: string;
    label: string;
    extraTownId: string;
  } | null>(null);

  const [selectGradeOption, setSelectGradeoptions] = useState<{
    id: string;
    label: string;
  } | null>(null);
  const [categoryOptions, setCategoryOptions] = useState<{
    id: string;
    label: string;
  } | null>(null);

  const [deletebtn, setDeletebtn] = useState(false);
  const [cityId, setCityID] = useState<any>(null);

  const [filterData, setFilterData] = useState<any>({ start: 1, length: 10 });

  //api
  const { data ,isLoading ,isSuccess } = useGETCities({
    enable: true,
    params: {
      id: null,
      start: filterData.start,
      length: filterData.length,
    },
  }); // data for table

  // console.log('CityCategoryData?.recordsTotal',data.data.recordsTotal);

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const { data: getallCityAndCategory, isSuccess: cityDropDownSuccess } =
    useAllCityAndCategory({ enable: true });
  // console.log("getallCityAndCategory", getallCityAndCategory);

  const CityDataArray = data?.data?.data || [];

  const cityDataforDropDown = CityDataArray.map(
    (item: ApiresponseDropDownData, index: number) => {
      return {
        id: item?.Citycategoryid || "",
        label: item?.Cityname || "Unknow city",
        // id:item?.value?.Icityid || '',
        extraTownId: item?.Itownid || "",
      };
    }
  );

  const categroyDataForDropDown =
    cityDropDownSuccess && getallCityAndCategory?.data?.data?.category
      ? Object.entries(getallCityAndCategory?.data?.data?.category).map(
          ([key, value]) => ({
            id: key,
            label: value ? String(value) : "unknown category",
          })
        )
      : [];

  const cityDataArray = data?.data?.data || [];
  // data for table

  const { data: gradeMasterDataa } = useGradeMastersData({ enable: true });
  const formattedGradeData = gradeMasterDataa?.data.map((item: any) => ({
    id: item.Gradeid,
    label: item.GradeName.trim(),
  }));

  // add city
  const { mutate: addCity } = useAddCityCategory();
  const { mutate: UpdateCity } = UpdateCities();
  const { mutate: delectCity } = useDeleteCity();

  // Data for Tabel
  const CityCategoryData = cityDataArray.map(
    (item: cityResponse, index: number) => ({
      Name: item.Cityname.trim(),
      Category: item.Category,
      Itownid: item.Itownid,
      Grade: item.GradeMaster?.GradeName || "N/A",
      Cid: item?.Citycategoryid,
      Gid: item?.GradeMaster?.Gradeid,
    })
  );
  // console.log('CityCategoryData?.recordsTotal',CityCategoryData?.recordsTotalCityCategoryData?.recordsTotal)

  const handleCategoryEdit = (row: any) => {
    // console.log("row", row);
    setEditCity(row);
    setCityID(row.Cid);

    setIsModal(true);
    setDeletebtn(true);

    setSelectCityOptions({
      id: row.Cid,
      label: row.Name,
      extraTownId: row.Itownid,
    });
    setCategoryOptions({ id: row.Cid, label: row.Category });
    setSelectGradeoptions({ id: row.Gid, label: row.Grade });
  };

  const handledeleteCity = () => {
    // console.log("cityId", cityId);
    const deleteCityID = Number(selectCityOptions?.id);
    // delectCity(cityId);
    delectCity(deleteCityID);

    setIsModal(false);
    setDeletebtn(false);
  };

  const CityCategoryColumns = [
    {
      name: "Name",
      selector: (row: { Name: string }) => row.Name,
    },
    {
      name: "Category",
      selector: (row: { Category: number }) => row.Category,
    },
    {
      name: "Grade",
      selector: (row: { Grade: number }) => row.Grade,
    },
    {
      name: "Action",
      width: "120px",
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <button
            onClick={() => handleCategoryEdit(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center"
            style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
          >
            <FaEdit style={{ fill: "#fff" }} size={20} /> Edit
          </button>
        </div>
      ),
    },
  ];

  const toggelModal = () => {
    setIsModal(!isModal);

    // if (!isModal) {
    setEditCity(null);
    // }
    setSelectCityOptions(null);
    setCategoryOptions(null);
    setSelectGradeoptions(null);
    setDeletebtn(false);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    //  console.log('cityId',cityId);
    if (editCity != null) {
      UpdateCity({
        // id: Number(selectCityOptions?.id) || 0,
        id: cityId || 0,
        Reqbody: {
          // Itownid: Number(selectCityOptions?.id) || 0,
          Itownid: Number(selectCityOptions?.extraTownId) || 0,
          // Itownid: Number(townId),
          LocationAutoComplete_Itownid: selectCityOptions?.label || "",
          Category: categoryOptions?.id || "",
          GradeId: Number(selectGradeOption?.id),
        },
      });

      setSelectCityOptions(null);
      setCategoryOptions(null);
      setSelectGradeoptions(null);
      
      setDeletebtn(false);
      setIsModal(!isModal);

    } else {
      // Add city 
      if(selectCityOptions != null && categoryOptions != null && selectGradeOption != null){
        const body = {
          // Itownid: Number(selectCityOptions?.id) || 0,
          Itownid: Number(selectCityOptions?.extraTownId) || 0,
          LocationAutoComplete_Itownid: selectCityOptions?.label || "",
          Category: categoryOptions?.id || "",
          GradeId: Number(selectGradeOption?.id),
        };
      addCity({ Reqbody: body });
      setIsModal(!isModal);
      // clear the states
      setSelectCityOptions(null);
      setCategoryOptions(null);
      setSelectGradeoptions(null);
      }else{
        showToast.warning('Fill the Mandatory Fields')
      }
    }
  };

  const handleClose = () => {
    setIsModal(false);
    setEditCity(null);
    setSelectCityOptions(null);
    setCategoryOptions(null);
    setSelectGradeoptions(null);
  };

  return (
    <div className="p-2">
      <PageHeader title="City Categroy" />
      <div className="row mb-0">
        <BasicDataTable
          Title="City Category"
          showSpinner={isLoading}
          columns={CityCategoryColumns}
          data={CityCategoryData}
          headerContent={
            <TableButton
              title="Add City"
              onClick={() => setIsModal(true)}
              style={{ marginRight: "8px" }}
            />
          }
          onChangePage={(pageNo: number) => {
            handlePagination(pageNo);
          }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
            handleonChangeRowsPerPage(newPerPage, page);
          }}
          paginationTotalRows={data?.data?.recordsTotal || 0}
        />
      </div>
      <RouteModal
        title={editCity ? "Edit City-Category" : "Add City-Category"}
        isOpen={isModal}
        size="md"
        toggle={toggelModal}
        content={
          <form onSubmit={handleSubmit}>
            <div className="col-md-12">
              <div className="col-md-12 mt-2">
                {/* This is going to be changed GET API for city */}
                <ReusableDropdown
                  label={
                    selectCityOptions?.label == ""
                      ? "Delhi"
                      : selectCityOptions?.label
                  }
                  DropdownHeading="City"
                  heading="City"
                  height="42px"
                  border="0.5px solid #D1D1D1"
                  options={!cityDropDownSuccess ? [] : cityDataforDropDown}
                  onSelect={(option: any) => {
                    // console.log("City-option-op", option);
                    setSelectCityOptions(option);
                  }}
                />
              </div>

              <div className="col-md-12 mt-2">
                <ReusableDropdown
                  DropdownHeading="Category"
                  label={
                    categoryOptions?.label == ""
                      ? "Category"
                      : categoryOptions?.label
                  }
                  height="42px"
                  heading="Category"
                  border="0.5px solid #D1D1D1"
                  options={!cityDropDownSuccess ? [] : categroyDataForDropDown}
                  onSelect={(option: any) => {
                    console.log("Cateory-option-op", option);
                    setCategoryOptions(option);
                  }}
                />
              </div>

              <div className="col-md-12 mt-2">
                <ReusableDropdown
                  DropdownHeading="Grade"
                  label={
                    selectGradeOption?.label == ""
                      ? "Grade"
                      : selectGradeOption?.label
                  }
                  height="42px"
                  heading="Grade"
                  border="0.5px solid #D1D1D1"
                  options={formattedGradeData || []}
                  onSelect={(option: any) => {
                    console.log("Grade-option-op", option);
                    setSelectGradeoptions(option);
                  }}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-start mt-3 gap-2 flex-wrap">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
              >
                {editCity ? "Update" : "Save"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={handleClose}
              >
                Cancel
              </Btn>
            </div>
          </form>
        }
      />
    </div>
  );
};

export default CityCategory;
